var render = function render(){var _vm=this,_c=_vm._self._c;return _c('a',{class:{'has-notification': _vm.displayNotification},attrs:{"href":"#"},on:{"click":function($event){$event.preventDefault();return _vm.showMessages()}}},[_c('i',{staticClass:"material-icons",attrs:{"data-toggle":"tooltip","title":"Enviar mensaje"}},[_vm._v("message")])])
}
var staticRenderFns = []

export { render, staticRenderFns }